import { useCallback } from 'react';

export const useMessage = () => {
	const sendMessage = useCallback(({ type, value }: { type: string; value: any }) => {
		window.parent.postMessage(JSON.stringify({ type, value }), '*');
	}, []);
	return [sendMessage];
};
